import React from "react";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { Feed, Loader } from "semantic-ui-react";
import UserAvatar from "components/UserAvatar";
import { GET_STUDENT_REPORT_ACTIVITY } from "../GraphQL";
const actionMap = {
  READ: "viewed",
  WRITE: "edited",
};

const descriptionMap = {
  write: "I provide services and I am contributing to this report.",
  read: "I provide services and I am reading this report.",
  audit: "I am reviewing this report for educational decision making.",
};

const ReportActivity = ({ studentId, reportId }) => {
  const { error, loading, data } = useQuery(GET_STUDENT_REPORT_ACTIVITY, {
    variables: { studentId, reportId },
  });

  if (loading) {
    return <Loader active size="tiny" />;
  }
  if (error) {
    throw error;
  }

  const entries = data.getStudent.report.log;

  return (
    <Feed size="small">
      {entries ? (
        entries.map((entry, i) => (
          <Feed.Event key={`entry${i}`}>
            <Feed.Label>
              <UserAvatar name={entry.name} useSvg />
            </Feed.Label>
            <Feed.Content>
              <Feed.Summary>
                <Feed.User>{entry.name}</Feed.User> {actionMap[entry.action]}{" "}
                this report
                <Feed.Date>{moment(entry.date).fromNow()}</Feed.Date>
              </Feed.Summary>
              {entry.description ? (
                <Feed.Extra text>
                  {`"${descriptionMap[entry.description]}"`}
                </Feed.Extra>
              ) : null}
            </Feed.Content>
          </Feed.Event>
        ))
      ) : (
        <p>No activity</p>
      )}
    </Feed>
  );
};

export default ReportActivity;
